import { FC, useEffect, useRef, useState } from 'react';
import SwiperCore from 'swiper';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper/types/swiper-options';

import styles from './business-hub-In-action-carousel.module.scss';
export interface InActionCarouselProps {
    title: string;
    items: {
        subTitle: string;
        title: string;
        description: string;
        image: string;
        banner: string;
    }[];
}

const options: SwiperOptions = {
    spaceBetween: 10,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: false,
    loop: true,
    effect: 'fade',
    pagination: {
        enabled: true,
        clickable: true,
    },
    speed: 1000,

    // autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    // },

    slidesPerGroupSkip: 0,

    breakpoints: {
        998: {
            watchOverflow: true,
        },
    },
};

const BusinessHubInActionCarousel: FC<InActionCarouselProps> = (props) => {
    const { title, items = [] } = props;

    const containerRef = useRef<HTMLDivElement>(null);
    const [swiper, setSwiper] = useState<SwiperCore>();

    useEffect(() => {
        if (!swiper) return;
        if (!containerRef.current) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries)
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {
                        swiper.params.autoplay = { delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true };
                        swiper.update();
                        swiper.autoplay.start();
                        observer.disconnect();
                    }
                });
        });

        observer.observe(containerRef.current);

        return () => {
            observer.disconnect();
        };
    }, [containerRef, swiper]);

    return (
        <div ref={containerRef} className={styles.container}>
            <div className={styles.wrapperContent}>
                <div className={styles.header}>{title}</div>
                <div className={styles.content}>
                    <Swiper {...options} onInit={(swiper: SwiperCore) => setSwiper(swiper)} modules={[Pagination]}>
                        {items.map((item, index) => {
                            return (
                                <SwiperSlide key={item.title}>
                                    <div key={index} className={styles.item}>
                                        <div className={styles.image}>
                                            <img className={styles.desktop} src={item.banner} alt="" />
                                            <img className={styles.mobile} src={item.image} alt="" />
                                        </div>

                                        <div className={styles.wrapperText}>
                                            <div className={styles.subTitle}>{item.subTitle}</div>
                                            <div className={styles.title}>{item.title}</div>
                                            <div className={styles.description}>{item.description}</div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default BusinessHubInActionCarousel;
